var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripadvisorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 63.997 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18.19 12.84) scale(.56811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.28 0C73.612 0 60.36 3.694 49.91 10.523l-17.58.016s4.148 5.537 5.494 11.12L82.318 55.8l5.972 8.928 6.03-9.004 44.596-34.088c1.324-5.62 5.52-11.23 5.52-11.23l-18.734-.013C115.194 3.603 102.424 0 88.278 0z",
    fill: "#000a12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.484 10.318a28.015 28.015 0 00-8.839 1.695 27.91 27.91 0 00-15.777 14.603c-1.418 3.075-2.22 6.326-2.475 9.597C87.35 21.873 75.515 10.497 60.98 10.2c8.04-3.44 17.278-5.3 27.29-5.3 10.08 0 19.18 1.817 27.213 5.418",
    fill: "#fcc40f"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000a12"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 25.132,
    cy: 39.396,
    cx: 60.072,
    fill: "#fff",
    strokeWidth: 5.847
  }), /*#__PURE__*/React.createElement("circle", {
    r: 11.3,
    cy: 39.396,
    cx: 60.072,
    fill: "none",
    strokeWidth: 5.102
  })), /*#__PURE__*/React.createElement("circle", {
    r: 4.667,
    cy: 39.396,
    cx: 60.072,
    fill: "#ef6a45"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000a12"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 25.132,
    cy: 39.346,
    cx: 116.615,
    fill: "#fff",
    strokeWidth: 5.847
  }), /*#__PURE__*/React.createElement("circle", {
    r: 11.3,
    cy: 39.346,
    cx: 116.615,
    fill: "none",
    strokeWidth: 5.102
  })), /*#__PURE__*/React.createElement("circle", {
    r: 4.667,
    cy: 39.346,
    cx: 116.615,
    fill: "#00b087"
  }))));
}
export default SvgTripadvisorIcon;